import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/services/actions/plan.service';

@Component({
  selector: 'app-pagar-plano',
  templateUrl: './pagar-plano.component.html',
  styleUrls: ['./pagar-plano.component.scss']
})
export class PagarPlanoComponent implements OnInit {

  professionalPlanId
  plan
  transaction

  constructor(
    private route: ActivatedRoute,
    private planService: PlanService
  ) { }

  ngOnInit() {
    this.professionalPlanId = this.route.snapshot.queryParams['plan_id']
    this.getPaymentPlan()
  }

  getPaymentPlan () {
    this.planService
      .getPaymentPlan(this.professionalPlanId)
      .subscribe(
        (res) => {
          if (res['transaction'] && res['plan']) {
            this.plan = res['plan']
            this.transaction = res['transaction']
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

}
